import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import useSectionLevel from '../useSectionLevel';
import withThemeProps from '../withThemeProps';

function Heading(_ref) {
  var ElementType = _ref.as,
      level = _ref.level,
      rest = _objectWithoutProperties(_ref, ["as", "level"]);

  var currentLevel = useSectionLevel(); // Allow dynamic level values based on the current level.
  // For example, you could go "up" one level via:
  // `level={currentLevel => currentLevel - 1}`

  if (typeof level === 'function') {
    level = level(currentLevel);
  } // Ensure the output level can't be less than 1.


  var headingLevel = Math.max(1, level == null ? currentLevel : level);

  if (ElementType == null) {
    // If `headingLevel` is greater than 6, render an `h6` still because that's
    // the maximum provided by HTML. The real level will still be indicated by
    // `aria-level`.
    ElementType = "h".concat(Math.min(6, headingLevel));
  }

  return /*#__PURE__*/React.createElement(ElementType, _extends({
    role: "heading",
    "aria-level": headingLevel
  }, rest));
}

Heading.displayName = 'Heading';
export default withThemeProps(Heading, {
  section: 'heading',
  defaultVariant: 'primary'
});